import { useState, useEffect } from 'react'
import { Alert } from 'react-bootstrap';
import {API_ROOT} from '../AppConfig/app-config'

export default function Welcome() {
    const [apiResponse, setApiResponse] = useState("");

    useEffect(() => {
        fetch(`${API_ROOT}/welcome`)
        .then(res => res.text())
        .then(res => setApiResponse(res))
        .catch(error => console.error("Welcome API error:", error));
    }, []);

    return (
        <div>
            <Alert variant="secondary">
            <p className="mb-0">Contact Number:  <a href="tel:+(91)7798884419">{apiResponse}</a></p>
            </Alert>
        </div>
    )
}
